import { createClient as _createClient } from 'contentful';

const defaultConfig = {
  CTF_SPACE_ID: process.env.CTF_SPACE_ID || '',
  CTF_CDA_ACCESS_TOKEN: process.env.CTF_CDA_ACCESS_TOKEN || '',
  CTF_CMA_KEY: process.env.CTF_CMA_KEY || ''
};

export function createClient(config = defaultConfig) {
  return _createClient({
    space: config.CTF_SPACE_ID,
    accessToken: config.CTF_CDA_ACCESS_TOKEN
  });
}
